
import { useEffect } from "react";

/** Tags whichever element is actively scrolling with `.is-scrolling`, removed
 *  ~0.8s after the last scroll event. globals.css keeps scrollbar thumbs
 *  transparent except on `.is-scrolling`, so bars only show while scrolling. */
export function ScrollbarAutohide() {
  useEffect(() => {
    const timers = new Map<Element, number>();
    function onScroll(e: Event) {
      const el = e.target instanceof Element ? e.target : document.documentElement;
      el.classList.add("is-scrolling");
      window.clearTimeout(timers.get(el));
      timers.set(
        el,
        window.setTimeout(() => {
          el.classList.remove("is-scrolling");
          timers.delete(el);
        }, 800),
      );
    }
    window.addEventListener("scroll", onScroll, { capture: true, passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll, { capture: true });
      timers.forEach((t) => window.clearTimeout(t));
    };
  }, []);
  return null;
}
